export default "__VITE_PUBLIC_ASSET__5bec64f9__"